export default defineNuxtPlugin((nuxtApp) => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet<Element>();
  const animations = new Set<Animation>();
  let observer: IntersectionObserver | undefined;
  const selector = [
    '.hero-copy > *',
    '.hero-visual',
    '.section-top',
    '.principles > *',
    '.package-card',
    '.steps > *',
    '.system-benefits > *',
    '.solution-panel',
    '.partner-hero h1',
    '.partner-lead',
    '.partner-identity',
    '.partner-section-heading',
    '.partner-feature-grid > *',
  ].join(',');

  function stop() {
    observer?.disconnect();
    animations.forEach((animation) => animation.cancel());
    animations.clear();
  }
  function observe() {
    stop();
    if (preference.matches || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(
      (entries) => {
        let order = 0;
        for (const entry of entries) {
          if (!entry.isIntersecting || seen.has(entry.target)) continue;
          seen.add(entry.target);
          observer?.unobserve(entry.target);
          // Content stays visible without JavaScript and never waits for a scroll event.
          const animation = entry.target.animate(
            [
              { opacity: 0.35, translate: '0 20px' },
              { opacity: 1, translate: '0 0' },
            ],
            {
              duration: 700,
              delay: Math.min(order++ * 65, 195),
              easing: 'cubic-bezier(.22,1,.36,1)',
              fill: 'backwards',
            },
          );
          animations.add(animation);
          animation.finished.then(
            () => animations.delete(animation),
            () => animations.delete(animation),
          );
        }
      },
      { threshold: 0.08, rootMargin: '0px 0px -24px 0px' },
    );
    document.querySelectorAll(selector).forEach((element) => {
      if (!seen.has(element)) observer?.observe(element);
    });
  }
  nuxtApp.hook('app:mounted', observe);
  nuxtApp.hook('page:finish', () => nextTick(observe));
  nuxtApp.hook('page:start', stop);
  preference.addEventListener('change', observe);
  if (import.meta.hot)
    import.meta.hot.dispose(() => {
      stop();
      preference.removeEventListener('change', observe);
    });
});
